import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

/**
 * A wrapper for routes that should only be accessible to unauthenticated users.
 * If a user is already logged in, they will be redirected to the dashboard.
 * Examples: Login page, Register page, Forgot Password page.
 */
const PublicOnlyRoute = () => {
  const { user } = useAuthStore();

  // If auth state is still loading, we might want to show nothing or a spinner
  // strictly speaking, but usually for "public only" routes, 
  // checking 'user' is enough. If we are unsure, we let them see the page.
  // However, to prevent flashing, let's assume if we have a user, we redirect.
  
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default PublicOnlyRoute;
